import FieldPopover from "../../../fields3/generic/popover/popover"
import FieldProgress_Popover from "./components/popover/popover"
import FieldProgress_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldProgress_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldConfig from "../../proto/field-config";
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups";
import FieldProgress_View from "./render/view";
import FieldProgress_ViewSmall from "./render/view-small";
import normalizeNumber from "../../import/normalize/normalize-number";
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module";
import FieldProgress_TableCell from "./render/table/table-cell";
import FieldProgress_Editable from "./render/editable/editable";

export default class FieldProgress extends FieldPopover {

    FIELD_DEFAULT_WIDTH = 100

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel          = "Progress"
        this.filterType         = null
        this.typeGroup          = GROUP_MISC
        this.typeDescription    = "Progress selector"
        this.icon               = 'i5-percent'

        this.isSearchable       = false;

        _.assign(this.components, {
            PopoverMenu         : FieldProgress_Popover,
            FormValueNotEmpty   : FieldProgress_FormValueNotEmpty,
            InlineValueNotEmpty : FieldProgress_InlineValueNotEmpty,
        })

        this.renderComponents.view      = FieldProgress_View
        this.renderComponents.viewSmall = FieldProgress_ViewSmall

        this.renderComponents.editable  = FieldProgress_Editable
        this.renderComponents.tableCell = FieldProgress_TableCell
    }

    sortValue(value: any, model?: any) {
        return !_.isNil(value) ? value : -1
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        let res: number | null = normalizeNumber(value)

        if (!_.isNil(res) && res >= 0 && res <= 100) {
            return res
        }
        return null
    }

}